var swiper = new Swiper(".trustedwork", {
  slidesPerView: 2,
  spaceBetween: 20,
  autoplay: {
    delay: 0,
    disableOnInteraction: false,
  },
  speed:3000,
  loop:true,
  breakpoints: {
    1024: {
      slidesPerView: 6,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 4,
      spaceBetween: 15,
    },
    640: {
      slidesPerView: 2,
      spaceBetween: 15,
    },
  },
});